import React, { useState } from "react";

import { RxCross2 } from "react-icons/rx";
import { Link } from "react-router-dom";

export default function Alertinterview({ data }) {
  // Filter: Only alerts where class_room_booked_status = "no"
  const alertsData = data.filter(item => item.teacher_interview_status === "pending");

  const [visibleAlerts, setVisibleAlerts] = useState(1); // default 3 alerts
  const [hiddenIds, setHiddenIds] = useState([]);        // manually closed alerts

  const handleClose = (id) => {
    setHiddenIds(prev => [...prev, id]);
  };

  const visibleList = alertsData
    .filter(item => !hiddenIds.includes(item.id))
    .slice(0, visibleAlerts);

  const remainingCount =
    alertsData.filter(item => !hiddenIds.includes(item.id)).length - visibleAlerts;

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      
      {visibleList.map(item => (
        <div
          key={item.id}
          style={{
            width: "100%",
            background: "#ffd6fc",
            padding: "12px 16px",
            borderRadius: "8px",
            marginBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderLeft: "5px solid #9900ff"
          }}
        >
          <div>
            <strong>{item.package_title}</strong> 
            
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Link to={`/schedule-meeting/${item.order_number}`} >
            <button
              
              style={{
                background: "#9900ff",
                color: "white",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer"
              }}
            >
            Schedule Interview
            </button>
</Link>
            <RxCross2
              size={20}
              style={{ cursor: "pointer" }}
              onClick={() => handleClose(item.id)}
            />
          </div>
        </div>
      ))}

      {/* MORE BUTTON */}
      {remainingCount > 0 && (
        <button
          onClick={() => setVisibleAlerts(alertsData.length)}
          style={{
            background: "#ccc",
            padding: "8px 14px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            marginTop: "8px",
            marginBottom:"15px"
          }}
        >
          +{remainingCount} More
        </button>
      )}
    </div>
  );
}
